const locale = {
    placeholder: 'Zeit auswählen',
    rangePlaceholder: ['Anfangszeit', 'Endzeit'],
};
export default locale;
